<script setup lang="ts">
import RcMinersSelect from '@/components/rc/common/RcMinersSelect.vue'
import type { IMinerIdentifier } from '@/types/rc/miners'
import { ref } from 'vue'

const selection = defineModel<undefined | IMinerIdentifier | IMinerIdentifier[]>({ required: true })

const props = withDefaults(
  defineProps<{
    customerId?: string
    multiple?: boolean
  }>(),
  { customerId: undefined, multiple: true }
)

const selectRef = ref<InstanceType<typeof RcMinersSelect>>()

const reset = () => {
  selectRef.value?.reset()
}

defineExpose({ reset })
</script>

<template>
  <RcMinersSelect
    ref="selectRef"
    v-model="selection"
    :filters="{ customer_id: props.customerId }"
    :multiple="multiple"
  />
</template>
